/**
 * Strips a leading "#l/<label>" segment from a URL while preserving the
 * pathname, search params, and any remaining hash content (e.g. trailing
 * "?voucher=…" or further path segments).
 *
 * The customer storefront uses HashLocationStrategy in places, and combined
 * deep links like `https://host/#l/STORE/?voucher=X` need the voucher portion
 * to survive the post-load cleanup that removes the consumed location label.
 */
export function buildUrlWithoutLocationLabel(
  href: string,
  locationLabel: string,
): string {
  const url = new URL(href);
  const escapedLabel = locationLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const cleanedHash = url.hash.replace(
    new RegExp(`^#l/${escapedLabel}/?`, 'i'),
    '',
  );
  url.hash =
    cleanedHash && !cleanedHash.startsWith('#')
      ? '#' + cleanedHash
      : cleanedHash;
  return url.pathname + url.search + url.hash;
}

export function hasLocationInHash(hash: string | null | undefined): boolean {
  return /^#l\//i.test(hash ?? '');
}
